import React, { useEffect, useState } from "react";
import { getSettingsData } from "services/_settings";
import Hero from "./components/Hero";
import About from "./components/About";
import Condition from "./condition";
import EducationalPage from "./educational";
import Spondyloarthritis from "./components/Spondyloarthritis";
import BlogPage from "./blog";
import Newsletter from "./components/Newsletter";

const Home = () => {
  const [settingData, setSettingData] = useState([]);

  const getInitialData = async () => {
    const response = await getSettingsData();
    if (response.isSuccess) {
      const settingsObject = response.data.reduce((acc, setting) => {
        acc[setting.key] = setting.value;
        return acc;
      }, {});

      setSettingData(settingsObject);
    }
  };

  useEffect(() => {
    getInitialData();
  }, []);

  return (
    <>
      <div className="body_overly"></div>
      <Hero />
      <About settingData={settingData} />
      <Condition isPagination={false} />
      <EducationalPage isPagination={false} />
      <Spondyloarthritis />
      <BlogPage isPagination={false} />
      <Newsletter />
    </>
  );
};

export default Home;
